export default __webpack_public_path__ + "static/media/white-check.ae900bbf.svg";